import { useEffect, useState } from "react";
import { PerfOverlay } from "./PerfDiagnosticsCard";

const OVERLAY_KEY = "llx_perf_overlay_enabled";

export const PerfOverlayMount = () => {
  const [enabled, setEnabled] = useState(
    () => typeof window !== "undefined" && localStorage.getItem(OVERLAY_KEY) === "1"
  );

  useEffect(() => {
    const sync = () => setEnabled(localStorage.getItem(OVERLAY_KEY) === "1");
    window.addEventListener("llx-perf-overlay-changed", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("llx-perf-overlay-changed", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  if (!enabled) return null;
  return <PerfOverlay />;
};